import { IconKey,IconPresentation } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconPresentation
};
//

const Recon = {

    id: 'authentication',
    title: 'Recon',
    type: 'group',
    display_id:'G',
    icon: icons.IconPresentation,
    children: [
        {
            id: 'FI',
            title: 'FI',
            type: 'item',
            display_id:38,
            url: '/Admin/Recon_Fi',
            breadcrumbs: false
        },
        {
            id: 'Nonfi',
            title: "Non FI",
            type: 'item',
            display_id: 39,
            url: '/Admin/Recon_NonFi',
            breadcrumbs: false
        },
        {
            id: 'FI Recon Report for Admin',
            title: "FI Recon Report for Admin",
            type: 'item',
            display_id: 43,
            url: '/Admin/Fi_Recon_Report',
            breadcrumbs: false
        },
        {
            id: 'Non FI Recon Report for Admin',
            title: "Non FI Recon Report for Admin",
            type: 'item',
            display_id: 44,
            url: '/Admin/NonFi_Recon_Report',
            breadcrumbs: false
        },
    ]
}

export default Recon;
